// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { takeLatest } from 'redux-saga/effects';

import {
    upsertDeviceRegistrationInfo,
    checkEmailValidity,
} from './registerSagas';
import { GET_REGISTER_INFO_DATA, GET_JARVIS_DATA } from './../../../store/orderCreation';

export default [
    takeLatest(GET_REGISTER_INFO_DATA, upsertDeviceRegistrationInfo),
    takeLatest(GET_JARVIS_DATA, checkEmailValidity),
];
